import { Anchor, Group, Text } from '@mantine/core';

interface InfoRowProps {
    label: string;
    value: string | null | undefined;
    isLink?: boolean;
}

/**
 * Shared key-value row for the read-only detail cards. Used by both
 * VendorInfoCard and CandidateInfoCard so the Company Catalog and Candidate
 * Catalog detail views render identically.
 */
export const InfoRow = ({ label, value, isLink = false }: InfoRowProps): React.JSX.Element => {
    return (
        <Group gap="sm" align="baseline" data-testid="InfoRow">
            <Text size="sm" c="dimmed" w={140} style={{ flexShrink: 0 }}>
                {label}
            </Text>
            {isLink && value ? (
                <Anchor
                    href={value.startsWith('http') ? value : `https://${value}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    size="sm"
                >
                    {value}
                </Anchor>
            ) : (
                <Text size="sm">{value ?? '—'}</Text>
            )}
        </Group>
    );
};
